import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

import TokenActions from './TokenActions';
import AppNotifyService from '../services/AppNotifyService';
import LayoutActions from './LayoutActions';

const InAppActions = {
    startSession({
        deviceToken,
        appVersion,
        channel,
        disableAutoLogout,
        disableAccountNavigationLogout,
    } = {}) {
        AppDispatcher.dispatch({
            appVersion,
            channel,
            disableAutoLogout,
            disableAccountNavigationLogout,
            actionType: ActionTypes.IN_APP_SESSION_STARTED,
        });
        LayoutActions.setEmbedded(true);
        TokenActions.updateDevice(deviceToken);
    },

    notifyNavbar(title, goBack) {
        return AppNotifyService.notify('navbar', { title, goBack });
    },

    notifyOrderComplete() {
        return AppNotifyService.notify('order-complete');
    },

    reorderTrip(params) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.MOBILE_APP_RE_ORDER,
            params
        });
    },

    trigerMobileAppRating() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.MOBILE_APP_RATING_TRIGGERED
        });
    },

    setIsInApp(value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_IN_APP,
            value
        });
    }
};

export default InAppActions;
